import { API_CLIENTS_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedFileDownload } from '@eggplant/data-request'
import type { ReactElement } from 'react'

interface Props {
  id: string
  onSuccess: () => void
  children?: () => ReactElement
}

const DownloadApiClientsServiceRequest = ({
  id,
  onSuccess,
  children
}: Props) => {
  const url = `${API_CLIENTS_SERVICE}/api_clients/${id}/generate_secret`

  return (
    <AuthenticatedFileDownload
      children={children}
      fileType='text/csv'
      filename='api_access_key.csv'
      method='post'
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default DownloadApiClientsServiceRequest
